export const PRODUCT = 'A'
